
import React, { useState } from "react";
import { Card, Row, Col, Dropdown, Form } from "react-bootstrap";
import {
  BsThreeDotsVertical,


  BsGeoAlt,
  BsStarFill,
} from "react-icons/bs";
import { BsPencilSquare, BsTrash } from "react-icons/bs";
import {
  BsEnvelope,
  BsTelephone,
  BsChatDots,
  BsSkype,
  BsFacebook
} from "react-icons/bs";
// import EditCompanyModal from "./EditCompanyModal";
// import DeleteCompanyModal from "./DeleteCompanyModal";
import CompaniesHeader from '../../../components/crm/companies/CompaniesHeader'
import EditCompanyModal from "../../../components/modals/crm/companies/edit-companies/EditCompanyModal";
import DeleteCompanyModal from "../../../components/modals/crm/companies/edit-companies/DeleteCompanyModal";
import { Link } from "react-router-dom";
import AddCompaniesModal from "../../../components/modals/crm/companies/add-companies/AddCompaniesModal";
const CompaniesPage = () => {
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
 const[Company,setCompany]=useState(false)
const companies = [
  {
    name: "BrightWave Innovations",
    img: "/assets/img/company/company-12.svg",
    phone: "(163) 2459 315",
    country: "Germany",
    rating: 4.2,
  },
  {
    name: "Stellar Dynamics",
    img: "/assets/img/company/company-13.svg",
    phone: "(146) 1249 296",
    country: "USA",
    rating: 5.0,
  },
  {
    name: "Quantum Nexus",
    img: "/assets/img/company/company-14.svg",
    phone: "(158) 3459 596",
    country: "India",
    rating: 4.5,
  },
  {
    name: "EcoVision Enterprises",
    img: "/assets/img/company/company-15.svg",
    phone: "(135) 3489 516",
    country: "Canada",
    rating: 4.5,
  },

  // 🔽 ADD THESE (second row)
  {
    name: "Aurora Technologies",
    img: "/assets/img/company/company-16.svg",
    phone: "(196) 4862 196",
    country: "China",
    rating: 3.0,
  },
  {
    name: "BlueSky Ventures",
    img: "/assets/img/company/company-17.svg",
    phone: "(163) 6498 256",
    country: "Japan",
    rating: 5.0,
  },
  {
    name: "TerraFusion Energy",
    img: "/assets/img/company/company-18.svg",
    phone: "(154) 6481 075",
    country: "Indonesia",
    rating: 3.5,
  },
  {
    name: "UrbanPulse Design",
    img: "/assets/img/company/company-19.svg",
    phone: "(184) 6348 195",
    country: "Cuba",
    rating: 4.5,
  },
];
  return (
    <>
      {/* HEADER */}
  <div style={{ padding: "15px", background: "#f8f9fa",  }}
 >
     <CompaniesHeader
     openModal={() => setCompany(true)}
      title="Companies Grid"
     />

        <Card className="mb-3">
        <Card.Body className="d-flex justify-content-between align-items-center">
          <h5>Companies Grid</h5>

          <Dropdown>
            <Dropdown.Toggle variant="light" size="sm">
              Sort By : Last 7 Days
            </Dropdown.Toggle>
            <Dropdown.Menu align="end">
              <Dropdown.Item>Recently Added</Dropdown.Item>
              <Dropdown.Item>Ascending</Dropdown.Item>
              <Dropdown.Item>Descending</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Card.Body>
      </Card>

      {/* GRID */}
      <Row>
        {companies.map((company, index) => (
          <Col xl={3} lg={4} md={6} key={index}>
            <Card className="mb-4 shadow-sm">
              <Card.Body>

                {/* TOP */}
                <div className="d-flex justify-content-between align-items-start">
                  <Form.Check />

                  <img
                    src={company.img}
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                    }}
                  />

                  <Dropdown align="end">
                    <Dropdown.Toggle className="btn btn-sm border-0 bg-transparent text-dark">
                      <BsThreeDotsVertical />
                    </Dropdown.Toggle>

                   <Dropdown.Menu className="custom-dropdown">
  <Dropdown.Item
    className="dropdown-item-custom"
    onClick={() => {
      setSelectedCompany(company);
      setShowEdit(true);
    }}
  >
    <BsPencilSquare className="me-2" />
    Edit
  </Dropdown.Item>

  <Dropdown.Item
    className="dropdown-item-custom"
    onClick={() => {
      setSelectedCompany(company);
      setShowDelete(true);
    }}
  >
    <BsTrash className="me-2" />
    Delete
  </Dropdown.Item>
</Dropdown.Menu>
                  </Dropdown>
                </div>

                {/* TITLE */}
                <div className="text-center mt-2">
                  <h6>{company.name}</h6>

                  <div className="d-flex justify-content-center mt-2">
                    <img src="/assets/img/profiles/avatar-01.jpg" className="avatar" />
                    <img src="/assets/img/profiles/avatar-02.jpg" className="avatar" />
                    <img src="/assets/img/profiles/avatar-03.jpg" className="avatar" />
                    <span className="avatar-more">+1</span>
                  </div>
                </div>

                {/* DETAILS */}
                <div className="mt-3">
                  <p><BsEnvelope /> [email protected]</p>
                  <p><BsTelephone /> {company.phone}</p>
                  <p><BsGeoAlt /> {company.country}</p>
                </div>

                {/* FOOTER */}
                <div className="d-flex justify-content-between border-top pt-2">
               <div className="social-icons d-flex ">
  <Link to="/email" className="icon-box">
    <BsEnvelope />
  </Link>

  <Link to="/call" className="icon-box">
    <BsTelephone />
  </Link>

  <Link to="/chat" className="icon-box">
    <BsChatDots />
  </Link>

  <Link to="/skype" className="icon-box">
    <BsSkype />
  </Link>

  <Link to="/facebook" className="icon-box">
    <BsFacebook />
  </Link>
</div>

                  <span className="text-warning">
                    <BsStarFill /> {company.rating}
                  </span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* MODALS */}
      <EditCompanyModal
        show={showEdit}
        handleClose={() => setShowEdit(false)}
        company={selectedCompany}
      />

      <DeleteCompanyModal
        show={showDelete}
        handleClose={() => setShowDelete(false)}
        company={selectedCompany}
      />
<AddCompaniesModal    show={Company}
  handleClose={() => setCompany(false)} />

      {/* STYLE */}
      <style>{`
        .avatar {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          margin-left: -8px;
          border: 2px solid white;
        }

        .avatar-more {
          background: orange;
          color: white;
          border-radius: 50%;
          padding: 4px 8px;
          font-size: 12px;
          margin-left: -8px;
        }

// icons
.social-icons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon-box {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f5f6f8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #6c757d;
  text-decoration: none;
  transition: 0.2s;
}

.icon-box:hover {
  background: #e9ecef;
  color: #000;
}
// drop edit and delete

.custom-dropdown {
  border-radius: 10px;
  padding: 8px;
  min-width: 140px;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.dropdown-item-custom {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  padding: 8px 10px;
  border-radius: 6px;
  color: #333;
  transition: 0.2s;
}

.dropdown-item-custom:hover {
  background-color: #f5f6f8;
}

.dropdown-item-custom svg {
  font-size: 14px;
  color: #6c757d;
}
      `}</style>
  </div>
    </>
  );
};

export default CompaniesPage;